export const BLOCK_ORDER = ['1_day', '2_days', '3_days', 'over_3_days']

export const COMMIT_ALL_KEY = 'commit_all'

export const BLOCK_LABELS = {
    '1_day': { title: 'COMMIT 1 NGÀY', badge: 'commit < 48h', emphasize: true },
    '2_days': { title: 'COMMIT 2 NGÀY', badge: '48h ≤ commit < 72h', emphasize: false },
    '3_days': { title: 'COMMIT 3 NGÀY', badge: '72h ≤ commit < 96h', emphasize: false },
    'over_3_days': { title: 'COMMIT > 3 NGÀY', badge: 'commit ≥ 96h', emphasize: false },
    [COMMIT_ALL_KEY]: { title: 'COMMIT ALL', badge: null, emphasize: false, hideSkuCount: true },
}

export const sortBlocksByFixedOrder = (blocks) => {
    return BLOCK_ORDER
        .map((key) => blocks.find((b) => b.block === key))
        .filter(Boolean)
}

export const formatNumber = (value) => {
    const num = Number(value)
    if (value === null || value === undefined || value === '' || Number.isNaN(num)) return value
    return num.toLocaleString('vi-VN')
}

export const buildCommitAllBlock = (orderedBlocks, totalAll) => {
    const itemsByType = new Map()

    orderedBlocks.forEach((block) => {
        (block.items || []).forEach((item) => {
            const existing = itemsByType.get(item.type)
            if (existing) {
                existing.total += item.total
                existing.dateFullyDone = existing.dateFullyDone || !!item.dateFullyDone
            } else {
                itemsByType.set(item.type, {
                    type: item.type,
                    total: item.total,
                    dateFullyDone: !!item.dateFullyDone,
                })
            }
        })
    })

    let overdueCount = 0
    const items = Array.from(itemsByType.values())
    items.forEach((item) => {
        if (item.dateFullyDone) overdueCount += 1
    })

    return {
        block: COMMIT_ALL_KEY,
        total: totalAll,
        skuCount: items.length,
        overdueCount,
        items,
    }
}
